import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { UserGQL } from '@app/generated/graphql';
import { UserHelper } from '@app/core/helpers/user.helper';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ExistingUserGuard {
  private router = inject(Router);
  private userGql = inject(UserGQL);

  constructor() {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.userGql.fetch().pipe(
      map((res) => res.data.myUser),
      map((myUser) => UserHelper.isExistingUser(myUser)),
      tap((isExistingUser) => {
        if (!isExistingUser) {
          this.router.navigate(['account', 'settings']);
        }
      }),
    );
  }
}
